import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

export const api = axios.create({ baseURL: API });

// Attach Authorization header if a token is stored
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("scu_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Resolve a stored image reference into a full URL.
// - http(s)://... is returned as-is.
// - "/api/files/..." or "scu/uploads/..." is prefixed with the backend host.
export function resolveImage(src) {
  if (!src) return "";
  if (/^https?:\/\//i.test(src)) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return `${BACKEND_URL}/api/files/${src}`;
}
